import {Fade, FadeProps} from '@mui/material';
import React from 'react';

export const EFade = (props: FadeProps): React.ReactElement => (
  <Fade {...props} />
);
